import React from 'react';
import { router, AppRoute } from '@/lib/router';

interface AuthRequiredMessageProps {
  message: string;
  buttonText?: string;
  className?: string;
}

export const AuthRequiredMessage: React.FC<AuthRequiredMessageProps> = ({
  message,
  buttonText = "前往登录",
  className = ""
}) => {
  return (
    <div className={`flex items-center justify-center h-full ${className}`}>
      <div className="text-center">
        <p className="text-muted-foreground mb-4">{message}</p>
        <button 
          onClick={() => router.navigate(AppRoute.LOGIN)}
          className="px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors"
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
}; 